module.exports = __webpack_public_path__ + "img/avatar-male.9de87218.png";